<app-response-text
class="centered"
[lambdaMessage]="lambdaMessage"
[lambdaError]="lambdaError"
></app-response-text>

<div class="mainTable">
    <br>
    <div class="table-container">
        <app-data-grid 
            [(data)]="data.voicemails" 
            (itemChange)="updateItem($event)"
            [(isValid)]="formValid"
            [formTemplate]="form"
            [viewTemplate]="target" 
            [columnNames]="['DNIS', 'User', 'Voicemail #']"
            [spacing]="[1, 1, 1, 0.5]" 
            [itemsPerPage]="14"
            [objectBluePrint]="{'QueueConfig': {}}"
            (buttonEvent)="lambdaMessage=''; lambdaError=false; updateMode($event);"
            >
    
            <ng-template #form let-agent>
                <td><input name="DNIS" [disabled]="!newRow" class="d-form" placeholder="123-456-7890" type="text" [(ngModel)]="agent.DNIS" (ngModelChange)="validate(agent)"></td>
                <td><input name="agentName" class="d-form" placeholder="email" type="text" [(ngModel)]="agent.QueueConfig.agentName" (ngModelChange)="validate(agent)"></td>
                <td><input name="voicemail" class="d-form" placeholder="+1234567890" type="text" [(ngModel)]="agent.QueueConfig.voiceMail" (ngModelChange)="validate(agent)"></td>
            </ng-template>
        
            <ng-template #target let-agent>
                <td>{{agent.DNIS}}</td>
                <td>{{agent.QueueConfig.agentName}}</td>
                <td>{{agent.QueueConfig.voiceMail}}</td>
            </ng-template>
        
        </app-data-grid>
    </div>
</div> 
